import React from 'react';
import BarChartComp from '../../../components/barchart';
import {KeyDownEvent} from '../../../utils/eventKey'
import {
    WbEventHandlerMixins,
    WbDateYearFormat,
    WbMarkdownHtml
  } from '../../../utils/common';

const WorkStreamRow = ({item, id, toggleChkBox, selectedItems=[]}) => {
    const leader = (typeof item.ownerName !== 'undefined') ? item.ownerName : '';
    const labelText = (item.teamName) ? (item.teamName + (leader ? `<span class="dotClass"></span> ${leader}` : '') + (item.target_date && item.target_date > 0 ? `<span class="dotClass"></span> ${WbDateYearFormat.getFormateYeardDate(item.target_date)}` : '')) : leader;
    const subtitleText = (item.teamName) ? (item.teamName + (leader ? leader : '') + (item.target_date && item.target_date > 0 ? `${WbDateYearFormat.getFormateYeardDate(item.target_date)}` : '')) : leader;
    const type = id;
    return (
      <div key={`${type}_${item.id}`} className="rectbox-row ">
        <div className="rectbox-col">
          <div className="chkbox wbcheckboxcomp" data-testid="chkbox wbcheckboxcomp">
            {/* <input type="checkbox" className="css-checkbox" checked={item.checked} value={item.id} name="items[]" onChange={e => toggleChkBox(e, item)} id={`item-chk-${item.id}`} /> */}
            <span style={{cursor:'pointer'}}>
            <div 
              aria-checked={selectedItems.includes(item.id)}
              aria-label={`${(item.progress < 0 ? "--" : (item.progress > 100 ? "100 %" : item.progress + "%")) } ${item.name} ${subtitleText}`}
              className={selectedItems.includes(item.id) ? "checkbox-icon-checked" : "checkbox-icon-not-checked"}
              id={`item-chk-${item.id}`}
              onClick={e => toggleChkBox(e, item)}
              onKeyDown={(e) => {
                KeyDownEvent(e, () => toggleChkBox(e, item), false, true)
              }}
              role="checkbox"
              tabIndex="0"
              value={item.id}
            />
            </span>
            <label className="css-label modalParaText" htmlFor={`item-chk-${item.id}`} />
          </div>
        </div>
        <div className="rectbox-col">
          <BarChartComp count={item.progress} color={item.progress_color}/>
        </div>
        <div className="rectbox-col rectbox-col-goal rectbox-col-line">
          <div className="rectbox-title"  data-testid="rectbox-title">
            <span>
              {item.name}
            </span>
          </div>
          <div className="rectbox-subtitle" dangerouslySetInnerHTML={WbMarkdownHtml(labelText)}>
          </div>
        </div>
        {/* <div className="rectbox-col rectbox-col-ws-enddate rectbox-col-line" style={{ fontSize: '10px', width: '16%' }}>
          <div className="rectbox-ws-enddate">{WbDateYearFormat.getFormateYeardDate(item.target_date)}</div>
        </div> */}
      </div>
    );
};

export default WorkStreamRow;